export const VEHICLE_NOT_FOUND = 'No vehicle found';
export const SERVICE_THEME_NOT_FOUND = 'No service theme found';
export const TRY_AGAIN = 'Sorry, something went wrong. Try again later.';
